import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=6671f099&scoped=true&"
import script from "./MessageList.vue?vue&type=script&lang=ts&"
export * from "./MessageList.vue?vue&type=script&lang=ts&"
import style0 from "./MessageList.vue?vue&type=style&index=0&id=6671f099&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6671f099",
  null
  
)

export default component.exports